import { useCallback } from 'react';
import { useRequestState } from '@app/modules/mje/api/useRequestState';
import {
  MjeEnvelope,
  parseMjeValueResponse,
} from '@app/modules/mje/api/mjeResponse';
import { UserProfilePermissionResponse } from '@app/modules/mje/api/UserProfile/userProfile.types';
import { useHttpApi } from '@app/api/core/http.core.api';

const BASE_URL = '/v1/mje/user-profiles';

export const usePermissionAddAccountingEntries = () => {
  const http = useHttpApi();
  const { data, isLoading, error, safeExecute } = useRequestState<
    UserProfilePermissionResponse | undefined
  >();

  const fetchPermission = useCallback(() => {
    return safeExecute(async () => {
      const response = await http.get<
        MjeEnvelope<UserProfilePermissionResponse>
      >(`${BASE_URL}/permission/add-accounting-entries`);
      return parseMjeValueResponse<UserProfilePermissionResponse>(response.data)
        .data;
    }, 'Erro ao buscar permissão dos perfis de usuário');
  }, [http, safeExecute]);

  return {
    userProfilePermission: data,
    isLoading,
    error,
    fetchPermission,
  };
};
